import { connect } from 'react-redux'
import { setMenuSelectedState } from 'store/menu-selected/actions'
import Reporting from './Reporting'
import ReportingActions from '../../store/reports/actions' // eslint-disable-line
import { setSelectedReport } from '../../store/reports/actions' // eslint-disable-line
import { setEmbeddedReportName, fetchEmbeddedReport, fetchingEmbeddedReport } from '../../store/report-viewer/actions'
import { setReportRowSelected } from '../../store/report-row/actions'

const mapStateToProps = state => ({
  report: state.reports.report,
  reportOptions: state.reports.reportOptions,
  loading: state.reports.loading,
  features: state.features,
  reportTypes: state.reports.reportTypes,
  reportTypesLoading: state.reports.reportTypesLoading,
  reportTypesError: state.reports.error,
  embeddedReportName: state.reportViewerState.embeddedReportName,
  embeddedReport: state.reportViewerState.embeddedReport,
  fetchEmbeddedReportSucceeded: state.reportViewerState.succeeded,
  fetchingEmbeddedReport: state.reportViewerState.fetching,
  selectedReportType: state.reports.selectedReportType,
  viewedEmbeddedReport: state.reportViewerState.viewed
})

const mapDispatchToProps = dispatch => ({
  loadReport: (reportName, reportOptions) => {
    dispatch({ type: ReportingActions.fetchPending })
    dispatch({ type: ReportingActions.setReportOptions, reportOptions })
    dispatch({ type: ReportingActions.fetchReport, reportName, reportOptions })
  },
  fetchReportTypes: () => {
    dispatch({ type: ReportingActions.reportTypesFetchPending })
    dispatch({ type: ReportingActions.fetchReportTypes })
  },
  setMenuSelectedState: (state) => {
    dispatch(setMenuSelectedState(state))
  },
  setSelectedEmbeddedReport: (embeddedReportName) => {
    dispatch(setEmbeddedReportName(embeddedReportName))
  },
  setSelectedReportType: (reportType) => {
    dispatch(setSelectedReport(reportType))
  },
  setReportRow: (row) => {
    dispatch(setReportRowSelected(row))
  },
  fetchEmbeddedReport: (reportName) => {
    dispatch(fetchingEmbeddedReport())
    dispatch(fetchEmbeddedReport(reportName))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Reporting)



// WEBPACK FOOTER //
// ./src/components/Reporting/index.jsx